import { Yield } from '../../abacus/interfaces/yield.interface'

export const purposeYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
